/**
 * A class to help with BigQuery SQL function calls.
 * It provides a static method to generate a SQL function call string.
 */
export class BQSqlFunctionHelper {
    public static VERSION_HIERARCHY = `am-lastarchon-bi-prod.bi_config.VERSION_HIERARCHY`;

    /**
     * Generates a BigQuery SQL function call.
     * @param functionName The name of the SQL function to call.
     * @param args The arguments to pass to the SQL function.
     * @returns A string representing the SQL function call.
     */
    public static getCallSqlStatement(
        functionName: string,
        ...args: any[]
    ): string {
        return `\`${functionName}\`(${args.join(', ')})`;
    }
}
